<template>
	<div>
		<warning-box 
      v-if="old_session_active"  
      @yes="applySession"
      @no="goToHome"
      title="Session"
      :body="'You still have an active session with name'+this.getRestaurantAuth().name+'. Are you sure want to use another session?'"
      btn_primary="Yes"
      btn_secondary="No" /> 
		<loader v-else />
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
  import {get} from '@/services/index.js';
  import WarningBox from '@/components/general/WarningBox'

	export default{
		components:{
			WarningBox
		},
		data(){
			return{
				old_session_active: false,
			}
		},
		mounted(){
			if(this.getRestaurantAuth().session != ''){
				console.log("A")
				this.validateSession().then(res=>{
					if(res === true){
						this.old_session_active = true
					}else{
						this.applySession()
					}
				})
			}else{
				console.log("B")
				this.applySession()
			}
		},
		methods:{
      ...mapGetters(['getMerchant','getRestaurantAuth']),
      ...mapMutations(['setRestaurantAuth']),
			goToHome(){
	      this.$router.push({
	        path: "/" + this.getMerchant().code,
	      });
	    },
	    applySession(){
	    	let params1 = [
					{
						key: 'session',
		    		value: this.$route.params.session	
					},
				]
				this.setRestaurantAuth(params1)
	    	this.validateSession(false).then(res=>{
	    		let params = [
						{
							key: 'name',
			    		value: res.data.customer_detail.name	
						},
						{
							key: 'session',
			    		value: res.data.session	
						},
					]
					this.setRestaurantAuth(params)
					this.goToHome()
	    	})
	    },
	    validateSession(old_way=true){
	    	return new Promise(done=>{
		    	get("CORE_RESTO","v2/session/validate",{
						merchant_id: this.getMerchant().id
					},'restaurant_session').then(response=>{
						let res = response.data
						if(!old_way){
							done(res)
						}
						if(res.success){
							done(true)
						}else{
							let params = [
								{
									key: 'name',
					    		value: ''	
								},
								{
									key: 'session',
					    		value: ''	
								},
							]
							this.setRestaurantAuth(params)
							done(false)
						}
					})
	    	})
	    },
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/restaurant/applySession.vue